import { error } from "jquery";
import { BASE_URL } from "../../utils/Constants";

export const GET_MENU_SUBMENU = "GET_MENU_SUBMENU";

export const GET_CITY = "GET_CITY";
export const GET_STATE = "GET_STATE";
export const GET_ALL_DISTRICT = "GET_ALL_DISTRICT";
export const ALL_DATA_COUNT = "ALL_DATA_COUNT";

export const getMenuSubMenu = () => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}menu-submenu`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.message);
    }
    const result = await response.json();

    if (result.status) {
      dispatch({
        type: GET_MENU_SUBMENU,
        data: result.data,
      });
    } else {
      throw new Error(result.message);
    }
  };
};

export const getState = () => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}get-states`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const result = await response.json();
      throw new error(result.message);
    }
    const result = await response.json();
    if (result.status) {
      dispatch({
        type: GET_STATE,
        data: result.data,
      });
    } else {
      throw new Error(result.message);
    }
  };
};

export const getCities = (stateId) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${BASE_URL}get-cities/${stateId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch cities.");
      }

      if (result.status) {
        dispatch({
          type: GET_CITY,
          data: result.data,
        });
      } else {
        throw new Error(result.message || "Failed to fetch cities.");
      }
    } catch (error) {
      console.error("Error fetching cities:", error.message);
      throw error; // Re-throw for further handling if needed
    }
  };
};

export const getAllDistrict = () => {
  return async (dispatch) => {
    try {
      const response = await fetch(`${BASE_URL}get-all-district`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch district.");
      }

      if (result.status) {
        dispatch({
          type: GET_ALL_DISTRICT,
          data: result.data,
        });
      } else {
        throw new Error(result.message || "Failed to fetch district.");
      }
    } catch (error) {
      console.error("Error fetching district:", error.message);
      throw error; // Re-throw for further handling if needed
    }
  };
};

export const getAllCount = () => {
  return async (dispatch) => {
    const response = await fetch(`${BASE_URL}all-count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.message);
    }
    const result = await response.json();

    if (result.status) {
      dispatch({
        type: ALL_DATA_COUNT,
        data: result.data,
      });
    } else {
      throw new Error(result.message);
    }
  };
};
